import { render, staticRenderFns } from "./ViessmannVitotrans353VT2_2d00_Kaskade.vue?vue&type=template&id=4bf03574&"
import script from "./ViessmannVitotrans353VT2_2d00_Kaskade.vue?vue&type=script&lang=js&"
export * from "./ViessmannVitotrans353VT2_2d00_Kaskade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports